export const PURCHASE_CONDITION_QUERY_KEY = 'purchase_amount_comparison';
export const OCCURRENCE_CONDITION_QUERY_KEY = 'occurrence_comparison';
export const WINDOW_CONDITION_QUERY_KEY = 'window';
export const PROPERTY_QUERY_KEY = 'property_comparison';

export const OCCURRENCE_CONDITION_LEFT_COL_TEXT = 'with occurrences';
export const WINDOW_CONDITION_LEFT_COL_TEXT = 'within a';
export const PURCHASE_CONDITION_LEFT_COL_TEXT = 'with total purchase amount';

export const WINDOW_CONDITION_DEFAULT_VALUE = '1_month';

export const CONDITION_TYPE_TO_LEFT_COL_TEXT = {
  [PURCHASE_CONDITION_QUERY_KEY]: PURCHASE_CONDITION_LEFT_COL_TEXT,
  [OCCURRENCE_CONDITION_QUERY_KEY]: OCCURRENCE_CONDITION_LEFT_COL_TEXT,
  [WINDOW_CONDITION_QUERY_KEY]: WINDOW_CONDITION_LEFT_COL_TEXT,
};

export const CONDITIONAL_TEXT = {
  or: 'or',
  and: 'and',
};

export const conditionOptions = [
  {
    id: WINDOW_CONDITION_QUERY_KEY,
    label: 'Within...',
    value: WINDOW_CONDITION_QUERY_KEY,
  },
];

export const purchaseConditionOptions = [
  {
    id: WINDOW_CONDITION_QUERY_KEY,
    label: 'Within...',
    value: WINDOW_CONDITION_QUERY_KEY,
  },
  {
    id: PURCHASE_CONDITION_QUERY_KEY,
    label: 'With total $ amount...',
    value: PURCHASE_CONDITION_QUERY_KEY,
  },
];

export const eventTypeToConditionOptions = {
  system: conditionOptions,
  purchase: purchaseConditionOptions,
  custom: conditionOptions,
};

export const comparatorOptions: Record<
  string,
  Array<{ id: string; label: string; value: string; Suffix?: string }>
> = {
  integer: [
    {
      id: 'doesNotEqual',
      label: 'Does not equal',
      value: 'doesNotEqual',
      Suffix: '≠',
    },
    {
      id: 'equals',
      label: 'Equals',
      value: 'equals',
      Suffix: '=',
    },
    {
      id: 'greaterThan',
      label: 'Greater than',
      value: 'greaterThan',
      Suffix: '>',
    },
    {
      id: 'greaterThanOrEqual',
      label: 'Great than or equal',
      value: 'greaterThanOrEqual',
      Suffix: '≥',
    },
    {
      id: 'isSet',
      label: 'Is set',
      value: 'isSet',
      Suffix: '∃',
    },
    {
      id: 'lessThan',
      label: 'Less than',
      value: 'lessThan',
      Suffix: '<',
    },
    {
      id: 'lessThanOrEqual',
      label: 'Less than or equal',
      value: 'lessThanOrEqual',
      Suffix: '≤',
    },
  ],
  long: [
    {
      id: 'doesNotEqual',
      label: 'does not equal',
      value: 'doesNotEqual',
      Suffix: '≠',
    },
    {
      id: 'equals',
      label: 'equals',
      value: 'equals',
      Suffix: '=',
    },
    {
      id: 'greaterThan',
      label: 'greater than',
      value: 'greaterThan',
      Suffix: '>',
    },
    {
      id: 'greaterThanOrEqual',
      label: 'greater than or equal',
      value: 'greaterThanOrEqual',
      Suffix: '≥',
    },
    {
      id: 'isSet',
      label: 'is set',
      value: 'isSet',
    },
    {
      id: 'lessThan',
      label: 'less than',
      value: 'lessThan',
      Suffix: '<',
    },
    {
      id: 'lessThanOrEqual',
      label: 'less than or equal',
      value: 'lessThanOrEqual',
      Suffix: '≤',
    },
  ],
  double: [
    {
      id: 'doesNotEqual',
      label: 'does not equal',
      value: 'doesNotEqual',
      Suffix: '≠',
    },
    {
      id: 'equals',
      label: 'equals',
      value: 'equals',
      Suffix: '=',
    },
    {
      id: 'greaterThan',
      label: 'greater than',
      value: 'greaterThan',
      Suffix: '>',
    },
    {
      id: 'greaterThanOrEqual',
      label: 'greater than or equal',
      value: 'greaterThanOrEqual',
      Suffix: '≥',
    },
    {
      id: 'isSet',
      label: 'is set',
      value: 'isSet',
    },
    {
      id: 'lessThan',
      label: 'less than',
      value: 'lessThan',
      Suffix: '<',
    },
    {
      id: 'lessThanOrEqual',
      label: 'less than or equal',
      value: 'lessThanOrEqual',
      Suffix: '≤',
    },
  ],
  string: [
    {
      id: 'contains',
      label: 'contains',
      value: 'contains',
    },
    {
      id: 'doesNotEqual',
      label: 'does not equal',
      value: 'doesNotEqual',
      Suffix: '≠',
    },
    {
      id: 'equals',
      label: 'equals',
      value: 'equals',
      Suffix: '=',
    },
    {
      id: 'isSet',
      label: 'is set',
      value: 'isSet',
    },
    {
      id: 'startsWith',
      label: 'starts with',
      value: 'startsWith',
    },
  ],
  boolean: [
    {
      id: 'doesNotEqual',
      label: 'does not equal',
      value: 'doesNotEqual',
      Suffix: '≠',
    },
    {
      id: 'equals',
      label: 'equals',
      value: 'equals',
      Suffix: '=',
    },
  ],
  object: [
    {
      id: 'isNot',
      label: 'is not',
      value: 'isNot',
    },
    {
      id: 'isExactly',
      label: 'is exactly',
      value: 'isExactly',
    },
    {
      id: 'isAfter',
      label: 'is after',
      value: 'isAfter',
    },
    {
      id: 'isOnOrAfter',
      label: 'is on or after',
      value: 'isOnOrAfter',
    },
    {
      id: 'isBetween',
      label: 'is between',
      value: 'isBetween',
    },
    {
      id: 'isSet',
      label: 'is set',
      value: 'isSet',
    },
    {
      id: 'isBefore',
      label: 'is before',
      value: 'isBefore',
    },
    {
      id: 'isOnOrBefore',
      label: 'is on or before',
      value: 'isOnOrBefore',
    },
  ],
  nested: [
    {
      id: 'contains',
      label: 'contains',
      value: 'contains',
    },
    {
      id: 'doesNotEqual',
      label: 'does not equal',
      value: 'doesNotEqual',
      Suffix: '≠',
    },
    {
      id: 'equals',
      label: 'equals',
      value: 'equals',
      Suffix: '=',
    },
    {
      id: 'greaterThan',
      label: 'greater than',
      value: 'greaterThan',
      Suffix: '>',
    },
    {
      id: 'greaterThanOrEqualTo',
      label: 'greater than or equal to',
      value: 'greaterThanOrEqualTo',
      Suffix: '≥',
    },
    {
      id: 'isNotSet',
      label: 'is not set',
      value: 'isNotSet',
    },
    {
      id: 'isSet',
      label: 'is set',
      value: 'isSet',
    },
    {
      id: 'lessThan',
      label: 'less than',
      value: 'lessThan',
      Suffix: '<',
    },
    {
      id: 'lessThanOrEqualTo',
      label: 'less than or equal to',
      value: 'lessThanOrEqualTo',
      Suffix: '≤',
    },
    {
      id: 'matchesRegex',
      label: 'matches regex',
      value: 'matchesRegex',
    },
    {
      id: 'startsWith',
      label: 'starts with',
      value: 'startsWith',
    },
  ],
  occurrences: [
    {
      id: 'doesNotEqual',
      label: 'does not equal',
      value: 'doesNotEqual',
      Suffix: '≠',
    },
    {
      id: 'equals',
      label: 'equals',
      value: 'equals',
      Suffix: '=',
    },
    {
      id: 'greaterThan',
      label: 'greater than',
      value: 'greaterThan',
      Suffix: '>',
    },
    {
      id: 'greaterThanOrEqual',
      label: 'greater than or equal',
      value: 'greaterThanOrEqual',
      Suffix: '≥',
    },
    {
      id: 'lessThan',
      label: 'less than',
      value: 'lessThan',
      Suffix: '<',
    },
    {
      id: 'lessThanOrEqual',
      label: 'less than or equal',
      value: 'lessThanOrEqual',
      Suffix: '≤',
    },
  ],
};

export const ComparatorOptionsWithNoValueRequirement = ['isSet', 'isNotSet'];
export const ComparatorOptionsWithNoSymbols = [
  'contains',
  'startsWith',
  'isSet',
  'matchesRegex',
  'isNotSet',
];
export const DefaultPropertyComparatorEq = 'equals';
export const DefaultPropertyComparatorContains = 'contains';

export const defaultOccurrenceComparatorValues = {
  value: '1',
  comparator: 'greaterThanOrEqual',
};

export const defaultPurchaseComparatorValues = {
  value: '1',
  comparator: 'greaterThanOrEqual',
};

export const GOAL_TYPES = {
  property: 'user',
  customEvent: 'custom',
  systemEvent: 'system',
  purchaseEvent: 'purchase',
};
